<template>
  <v-form @submit.prevent="search">
    <v-row>
      <v-col>
        <v-text-field
          :value="value"
          @input="updateValue"
          dense
          label="Hledání dle jména nebo e-mailu"
          name="search"
          type="text"
          outlined
        />
      </v-col>

      <v-col cols="auto">
        <v-btn depressed color="primary" height="40px"  min-width="125px" type="submit">
          Vyhledat
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: 'UserSearch',
  props: {
    value: {
      type: String,
      required: true,
      default: '',
    },
  },
  methods: {
    search() {
      this.$emit('search', this.value);
    },
    updateValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>
